<template>
  <div class="container news-container">
    <Header :banner="require('@/assets/images/banner/news.png')" />
    <section class="section section1">
      <!-- <div class="nav fcc font-size-16 mb50">
        <span class="active">公司新闻</span>
        <span class="">行业动态</span>
      </div> -->
      <div class="news-list percent80 box-center mb50">
        <div class="news fstart" v-for="(news, index) in list" :key="index">
          <div class="fcol">
            <div class="title font-blod mb10 font-size-18">
              {{news.title}}
            </div>
            <div class="time c_999 font-size-14 mb10">
              {{news.create_time}}
            </div>
            <div class="content c_333 font-size-14">
              {{news.brief}}
            </div>
            <!-- <div class="btn c_fff font-size-14">
              查看详情
            </div> -->
          </div>
        </div>
      </div>
      <div class="percent100">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :background="true"
          :current-page.sync="current_page"
          :page-size="page_size"
          layout="prev, pager, next, jumper"
          prev-text="上一页"
          next-text="下一页"
          :total="total">
        </el-pagination>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
export default {
  data() {
    return {
      page_size: 10,
      current_page: 1,
      total: 4,
      list: [
        {
          title: "5G给边缘计算带来了什么？",
          create_time: "2020-10-16",
          brief: "时下大热的5G和边缘计算有什么关系，它们的契合点在哪里？互联网IT域和通信网CT域如何融合？什么是云网一体化？阿里巴巴达摩院XG实验室高级技术专家南书、边缘计算团队高级技术专家屹平分享5G下，边缘计算的更多可能。"
        },
        {
          title: "自然语言处理在开放搜索中的应用",
          create_time: "2020-10-16",
          brief: "构建搜索引擎的时候，都会遇到很多效果优化的问题，其中很多都和自然语言处理相关。本文通过结合开放搜索中NLP技术要点进行解读和分析。"
        },
        {
          title: "通过Serverless技术降低微服务应用资源成本",
          create_time: "2020-10-16",
          brief: "从本质上来讲，微服务是一种架构风格，将一个大型的系统拆分为多个拥有独立生命周期的应用，应用之间采用轻量级的通信机制进行通信。这些应用都是围绕具体业务进行构建，可以独立部署、独立迭代，也可能根据业务负载独立的水平扩展。"
        },
        {
          title: "Spring是如何把Bean注册到IOC容器中的？",
          create_time: "2020-10-16",
          brief: "提到Spring就会想到IOC、DI等概念，这是Spring的核心思想，只要使用过Spring框架的人都知道这些概念，但要问到Spring具体是怎么实现IOC的，恐怕只能看Spring的源码才能找到答案，只要搞清楚两个问题，就能对Spring的整体脉络有个整体的认识。"
        }
      ]
    };
  },
  methods: {
    handleSizeChange(){

    },
    handleCurrentChange(){

    }
  },
  components: {
    Header,
    Footer
  },
};
</script>
<style lang="scss">
  .news-container {
    .el-pagination {
      text-align: center;
      .btn-prev,.btn-next, .el-pager li{
        border: 1px solid #e8e8e8;
        background-color: #fff !important;
        span {
          padding: 0 15px;
        }
      }
      .el-pager li.active {
        // color: #409EFF !important;
        background-color: #409EFF !important;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .container {
    .section1 {
      .nav {
        & > span {
          padding: 10px 20px;
          border: 1px solid rgba(0,0,0,.2);
          cursor: pointer;
          &.active {
            color: #fff;
            background-color: #2c8dd1;
          }
        }
      }
      .news-list {
        .news {
          position: relative;
          padding: 30px 30px 30px 30px;
          height: 150px;
          cursor: default;
          &:not(:nth-last-child(1)){
            border-bottom: 1px solid rgba(0,0,0,.2);
          }
          .content {
            display: -webkit-box;
            line-height: 22px;
            letter-spacing: 0.5px;
            max-height: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .btn {
            position: absolute;
            bottom: 30px;
            left: 30px;
            padding: 5px 10px;
            background-color: #2c8dd1;
            cursor: pointer;
          }
          &:hover {
            background-color: #f0f0f0;
            .title {
              color: #4097d4;
            }
          }
        }
      }
    }
  }

</style>